import React from 'react'
import { Text as TextComponent } from '@react-pdf/renderer'
import PropTypes from 'prop-types'

const Text = ({ children, style }) => (
  <TextComponent style={[{ fontFamily: 'Inter-Regular' }, style]}>
    {children}
  </TextComponent>
)

Text.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  style: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]),
}

Text.defaultProps = {
  style: null,
}

export default Text
